import styled from '@emotion/styled';

import useIntersectionAnimate from '../../../hooks/useIntersectionObserver';
import ComponentHeader from '../../../components/ComponentHeader/ComponentHeader';
import { ShipSmarterData } from './ShipSmarterData';
import ImageCard from '../../../components/Card/ImageCard';

const ShipSmarter = () => {
 useIntersectionAnimate('.intersection-animate', 'animate', {
  threshold: 0.1,
 });

 return (
  <Container className="intersection-animate">
   <ComponentHeader text="Ship Smarter with CML" />
   <CardRow>
    {ShipSmarterData.map((data, index) => (
     <ImageCard
      image={data.imageName}
      title={data.title}
      description={data.description}
      key={index}
     />
    ))}
   </CardRow>
  </Container>
 );
};

export default ShipSmarter;

const Container = styled.div`
 padding-bottom: 100px;
 display: flex;
 flex-direction: column;
 align-items: center;
 justify-content: center;
 gap: 40px;

 &.animate {
  --ydist: 100%;

  & > * {
   animation-duration: 0.3s;
   animation-delay: 0.3s;
   animation-timing-function: ease-out;
   animation-fill-mode: backwards;
  }

  & > *:first-of-type {
   animation-name: header-translate, text-opacity;
   animation-delay: 0.5s;
  }

  & > *:last-of-type {
   --ydist: 50%;
   animation-name: header-translate;
  }

  @keyframes header-translate {
   from {
    transform: translateY(var(--ydist));
   }
   to {
    transform: 0;
   }
  }

  @keyframes text-opacity {
   from {
    opacity: 0;
   }
   50% {
    opacity: 0;
   }
   to {
    opacity: 1;
   }
  }
 }

 @media (max-width: 884px) {
  align-items: center;
  padding-bottom: 55px;
 }
`;

const CardRow = styled.div`
 display: grid;
 width: 100%;
 max-width: 1280px;
 margin: 0 auto;
 gap: 24px;
 grid-template-columns: repeat(2, 1fr);

 @media (max-width: 600px) {
  grid-template-columns: 1fr;
 }
`;
